import {Guidebook} from '@chekin/core';
import {PATHS} from 'routes/constants';
import {useSummary} from 'context/summary';
import {useFetchGuidebooks} from 'hooks/guidebooks/useFetchGuidebooks';
import {useGuidebookNavigate} from 'hooks/guidebooks/useGuidebookNavigate';
import {GuidebooksList} from 'components/GuidebooksList';

function GuidebooksNavigationList() {
  const {navigateToGuidebook} = useGuidebookNavigate(PATHS.guidebook);
  const {reservationId} = useSummary();
  const {data} = useFetchGuidebooks({reservationId});
  const guidebooks = data?.items;

  const handleNavigate = (guidebook: Guidebook) => {
    navigateToGuidebook(guidebook, guidebook.guidebook_group_id);
  };

  if (!guidebooks?.length) return null;

  return <GuidebooksList guidebooks={guidebooks} onItemClick={handleNavigate} />;
}

export {GuidebooksNavigationList};
